import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=99eb2b1a&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=99eb2b1a&prod&lang=css"
import style1 from "./contact.vue?vue&type=style&index=1&id=99eb2b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99eb2b1a",
  null
  
)

export default component.exports